import { BiSolidUserPin } from "react-icons/bi";
import { BsBuildingsFill } from "react-icons/bs";
import { FaHistory, FaUserTie, FaSwatchbook } from "react-icons/fa";
import { GrNavigate } from "react-icons/gr";
import { HiMiniBuildingOffice2 } from "react-icons/hi2";
import { LuBadgeHelp } from "react-icons/lu";
import { LiaIndustrySolid } from "react-icons/lia";
import { MdLockPerson, MdOutlineSettingsSuggest } from "react-icons/md";
import { RiMenuSearchLine, RiRefund2Line } from "react-icons/ri";
import { TiWarning } from "react-icons/ti";
import { TbListDetails, TbDeviceAnalytics } from "react-icons/tb";
import { BsDiagram3 } from "react-icons/bs";
import { RiUserSettingsLine } from "react-icons/ri";

import uris, { externalLinks } from "../../../../config/uris";

const sidebarMenuData = [
    {
        id: 1,
        name: "Company Research",
        key: "company",
        type: "menu",
        refLink: [
            uris.companyResearch,
            uris.companyDisclosureDetails,
            uris.companyHistory,
            uris.companyInsights,
        ],
        icon: <HiMiniBuildingOffice2 />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 1.1,
                name: "Research Assistant",
                key: "company-research",
                type: "submenu",
                link: uris.companyResearch,
                icon: <HiMiniBuildingOffice2 />,
                active: true,
            },
            {
                id: 1.2,
                name: "My Portfolio",
                key: "company-manage-portfolio",
                type: "submenu",
                link: uris.portfolio,
                icon: <TbListDetails />,
                active: true,
            },
            {
                id: 1.3,
                name: "DocSource",
                key: "company-docsource",
                type: "submenu",
                link: uris.companyDisclosureDetails,
                icon: <TbListDetails />,
                active: true,
            },
            {
                id: 1.4,
                name: "History",
                key: "company-history",
                type: "submenu",
                link: uris.companyHistory,
                icon: <FaHistory />,
                active: true,
            },
            // {
            //     id: 1.4,
            //     name: "Insights",
            //     type: "submenu",
            //     link: uris.companyInsights,
            //     icon: (<MdAutoGraph />),
            //     active: true,
            // }
        ],
    },
    // {
    //   id: 8,
    //   name: "Fund Research",
    //   key: "fund",
    //   type: "menu",
    //   refLink: [
    //     uris.fundResearch,
    //     uris?.fundHistory
    //   ],
    //   icon: <RiRefund2Line />,
    //   active: false,
    //   showArrow: true,
    //   subMenu: [
    //     {
    //       id: 8.1,
    //       name: "Research Assistant",
    //       key: "fund-research",
    //       type: "submenu",
    //       link: uris.fundResearch,
    //       icon: <HiMiniBuildingOffice2 />,
    //       active: true,
    //     },
    //     {
    //       id: 8.2,
    //       name: "History",
    //       key: "fund-history",
    //       type: "submenu",
    //       link: uris.fundHistory,
    //       icon: <FaHistory />,
    //       active: true,
    //     },
    //   ],
    // },
    {
        id: 2,
        name: "Investor Research",
        key: "investor",
        type: "menu",
        refLink: [
            uris.investorResearch,
            uris.investorDisclosureDetails,
            uris.investorHistory,
            uris.investorInsights,
        ],
        icon: <FaUserTie />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 2.1,
                name: "Research Assistant",
                key: "investor-research",
                type: "submenu",
                link: uris.investorResearch,
                icon: <FaUserTie />,
                active: true,
            },
            {
                id: 2.2,
                name: "DocSource",
                key: "investor-docsource",
                type: "submenu",
                link: uris.investorDisclosureDetails,
                icon: <TbListDetails />,
                active: true,
            },
            {
                id: 2.3,
                name: "History",
                key: "investor-history",
                type: "submenu",
                refLink: [uris.investorHistory],
                link: uris.investorHistory,
                icon: <FaHistory />,
                active: true,
            },
            // {
            //     id: 2.4,
            //     name: "Insights",
            //     type: "submenu",
            //     refLink: [uris.investorInsights],
            //     link: uris.investorInsights,
            //     icon: (<MdAutoGraph />),
            //     active: true,
            // },
        ],
    },
    // {
    //     id: 3,
    //     name: "Real Estate Research",
    //     key: "real-estate",
    //     type: "menu",
    //     refLink: [
    //         uris.realEstateResearch,
    //         uris.realEstateDisclosureDetails,
    //         uris.realEstateHistory,
    //         uris.realEstateInsights
    //     ],
    //     icon: (<BsFillBuildingsFill />),
    //     active: false,
    //     showArrow: true,
    //     subMenu: [
    //         {
    //             id: 3.1,
    //             name: "Research Assistant",
    //             type: "submenu",
    //             link: uris.realEstateResearch,
    //             icon: (<BsFillBuildingsFill />),
    //             active: true,
    //         },
    //         // {
    //         //     id: 3.2,
    //         //     name: "DocSource",
    //         //     type: "submenu",
    //         //     link: uris.realEstateDisclosureDetails,
    //         //     icon: (<TbListDetails />),
    //         //     active: true,
    //         // },
    //         {
    //             id: 3.3,
    //             name: "History",
    //             type: "submenu",
    //             link: uris.realEstateHistory,
    //             icon: (
    //                 <FaHistory />
    //             ),
    //             active: true,
    //         },
    //         // {
    //         //     id: 3.4,
    //         //     name: "Insights",
    //         //     type: "submenu",
    //         //     link: uris.realEstateInsights,
    //         //     icon: (<MdAutoGraph />),
    //         //     active: true,
    //         // },
    //     ]
    // },
    {
        id: 4,
        name: "Private",
        key: "private",
        type: "menu",
        refLink: [uris.privateResearch],
        link: uris.privateResearch,
        icon: <MdLockPerson />,
        active: false,
        showArrow: false,
    },
    {
        id: 5,
        name: "Custom Research",
        key: "custom",
        type: "menu",
        refLink: [
            uris.customResearch,
            uris.customDisclosureDetails,
            uris.customHistory,
            uris.customInsights,
        ],
        icon: <RiMenuSearchLine />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 5.1,
                name: "Research Assistant",
                key: "custom-research",
                type: "submenu",
                link: uris.customResearch,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 5.3,
                name: "Manage My Files",
                key: "custom-manage",
                type: "submenu",
                link: uris.customDisclosureDetails,
                icon: <TbListDetails />,
                active: true,
            },
            {
                id: 5.4,
                name: "History",
                key: "custom-history",
                type: "submenu",
                link: uris.customHistory,
                icon: <FaHistory />,
                active: true,
            },
            // {
            //     id: 5.5,
            //     name: "Insights",
            //     type: "submenu",
            //     link: uris.customInsights,
            //     icon: (<MdAutoGraph />),
            //     active: true,
            // },
        ],
    },
    {
        id: 6,
        name: "Contro Research",
        key: "contro",
        type: "menu",
        refLink: [
            uris.controResearch,
            uris.controDisclosureDetails,
            uris.controHistory,
            uris.controInsights,
        ],
        icon: <TiWarning />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 6.1,
                name: "Research Assistant",
                key: "contro-research",
                type: "submenu",
                link: uris.controResearch,
                icon: <RiMenuSearchLine />,
                active: true,
            },
        ],
    },
    {
        id: 7,
        name: "ESG Playbooks",
        key: "playbook",
        type: "menu",
        refLink: [
            uris.esgPlaybookRegulations,
            uris.esgPlaybookFrameworks,
            uris.esgPlaybookScreeners,
            uris.managePlaybook,
            uris.playbookBatch,
            uris.createBatch
        ],
        icon: <FaSwatchbook />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 7.1,
                name: "Regulations",
                key: "playbook-regulations",
                type: "submenu",
                link: uris.esgPlaybookRegulations,
                icon: <RiMenuSearchLine />,
                active: true,
                isValidationRequired: true, // validate based on response stored in sessionStorage
            },
            {
                id: 7.2,
                name: "Frameworks",
                key: "playbook-frameworks",
                type: "submenu",
                link: uris.esgPlaybookFrameworks,
                icon: <RiMenuSearchLine />,
                active: true,
                isValidationRequired: true
            },
            {
                id: 7.3,
                name: "Screening",
                key: "playbook-screening",
                type: "submenu",
                link: uris.esgPlaybookScreeners,
                icon: <RiMenuSearchLine />,
                active: true,
                isValidationRequired: true
            },
            {
                id: 7.4,
                name: "Manage Playbook",
                key: "playbook-manage",
                type: "submenu",
                link: uris.managePlaybook,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 7.5,
                name: "Create Batch",
                key: "playbook-batch-create",
                type: "submenu",
                link: uris.createBatch,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 7.6,
                name: "Manage Batch",
                key: "playbook-batch-manage",
                type: "submenu",
                link: uris.playbookBatch,
                icon: <RiMenuSearchLine />,
                active: true,
            },
        ],
    },
    {
        id: 9,
        name: "Entities",
        key: "entity",
        type: "menu",
        refLink: [
            uris.uploadEntities,
            uris.manageEntity
        ],
        icon: <BsBuildingsFill />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 9.1,
                name: "Upload Entity",
                type: "submenu",
                link: uris.uploadEntities,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 9.2,
                name: "Manage Entity",
                type: "submenu",
                link: uris.manageEntity,
                icon: <RiMenuSearchLine />,
                active: true,
            }
        ],
    },
    {
        id: 10,
        name: "Labs",
        key: "labs",
        type: "menu",
        refLink: [
            uris.labsModelEvaluation,
            uris.labsPromptEvaluation,
            uris.labsHistory
        ],
        icon: <LiaIndustrySolid />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 10.1,
                name: "Model Evaluation",
                key: "labs-model-evaluation",
                type: "submenu",
                link: uris.labsModelEvaluation,
                icon: <GrNavigate />,
                active: true,
            },
            {
                id: 10.2,
                name: "Prompt Evaluation",
                key: "labs-prompts-evaluation",
                type: "submenu",
                link: uris.labsPromptEvaluation,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 10.3,
                name: "Chunk Evaluation",
                key: "labs-chunk-evaluation",
                type: "submenu",
                link: uris.chunkEvaluation,
                icon: <RiMenuSearchLine />,
                active: true,
            },
            {
                id: 10.4,
                name: "History",
                key: "prompts-history",
                type: "submenu",
                link: uris.labsHistory,
                icon: <FaHistory />,
                active: true,
            },
        ],
    },
    {
        id: 11,
        name: "Custom Workflows",
        key: "workflow",
        type: "menu",
        icon: <BsDiagram3 />,
        refLink: [
            uris.reviewEntities,
            uris.outputReview
        ],
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 11.1,
                name: "Gemini",
                type: "submenu",
                key: "workflow-gemini",
                refLink: [
                    uris.reviewEntities,
                    uris.outputReview,
                    uris.entityList
                ],
                icon: <RiMenuSearchLine />,
                active: false,
                showArrow: true,
                children: [
                    {
                        id: 12.1,
                        name: "Entity List",
                        type: "submenu",
                        key: "gemini-entity-list",
                        link: uris.entityList,
                        icon: <RiMenuSearchLine />,
                        active: true,
                    },
                    {
                        id: 12.2,
                        name: "Doc Review",
                        type: "submenu",
                        key: "gemini-doc-review",
                        link: uris.reviewEntities,
                        icon: <RiMenuSearchLine />,
                        active: true,
                    },
                    {
                        id: 12.3,
                        name: "Output Review",
                        type: "submenu",
                        key: "gemini-output-review",
                        link: uris.outputReview,
                        icon: <RiMenuSearchLine />,
                        active: true,
                    },
                    {
                        id: 12.4,
                        name: "View Metrics",
                        type: "submenu",
                        key: "gemini-metrics-view",
                        link: uris.viewMetrics,
                        icon: <RiMenuSearchLine />,
                        active: true,
                    },
                    {
                        id: 12.5,
                        name: "Prompt Evaluation",
                        type: "submenu",
                        key: "gemini-prompt-evaluation",
                        link: uris.geminiPromptEvaluation,
                        icon: <RiMenuSearchLine />,
                        active: true,
                    }
                ]
            },
        ],
    },
    {
        id: 13,
        name: "Dashboard",
        key: "dashboard",
        type: "menu",
        refLink: [
            uris.dashboard
        ],
        icon: <TbDeviceAnalytics />,
        active: false,
        showArrow: true,
        subMenu: [
            {
                id: 13.1,
                name: "Portfolio Metrics",
                key: "dashboard-portfolio-metrics",
                type: "submenu",
                link: uris.dashboard,
                icon: <GrNavigate />,
                active: true,
            },
            {
                id: 13.2,
                name: 'Data Extractor',
                key: 'data-extractor',
                type: 'submenu',
                link: uris.dataExtractor,
                icon: <GrNavigate />,
                active: true,
            },
            {
                id: 13.3,
                name: 'Portfolio Screening',
                key: 'portfolio-screening',
                type: 'submenu',
                link: uris.portfolioScreening,
                icon: <GrNavigate />,
                active: true,
            },
            {
                id: 13.4,
                name: 'Financed emissions & Climate risk',
                key: 'finance-emissions',
                type: 'submenu',
                link: uris.financeEmissions,
                icon: <GrNavigate />,
                active: true,
            }
        ]
    }
    // {
    //   id: 12,
    //   name: "Settings",
    //   key: "settings",
    //   type: "menu",
    //   refLink: [
    //     uris.portfolio
    //   ],
    //   icon: <RiUserSettingsLine />,
    //   active: false,
    //   showArrow: true,
    //   subMenu: [
    //     {
    //       id: 12.1,
    //       name: "My Portfolio",
    //       key: "settings-portfolio",
    //       type: "submenu",
    //       link: uris.portfolio,
    //       icon: <GrNavigate />,
    //       active: true,
    //     }
    //   ]
    // }
]

export const userHelperMenus = [
    // {
    //     id: 1,
    //     name: "Support",
    //     icon: <LuBadgeHelp />,
    //     // link: uris.support,
    //     isActive: true,
    //     action: "intercom-support",
    // },
    {
        id: 1,
        name: "Settings",
        icon: <MdOutlineSettingsSuggest />,
        link: uris.settings,
        isActive: true,
        restrictedUsers: ["trial-user"],
        unRestrictedUsers: ["louis.barbier@squarewell-partners.com", "esgds.io"]
    }
    // {
    //     id: 3,
    //     name: "Pricing",
    //     icon: <ImCreditCard />,
    //     link: uris.pricing,
    //     isActive: true
    // },
    // {
    //     id: 4,
    //     name: "Org Settings",
    //     icon: <FaRegBuilding />,
    //     link: uris.orgSettings,
    //     isActive: false
    // },
];

// Keep Ids starting from 101
export const additionalMenus = {
    bookDemo: {
        id: 101,
        name: "Book Demo",
        icon: <BiSolidUserPin />,
        link: externalLinks?.bookDemo,
        isExternal: true,
        isActive: true,
    },
};

// should be exact as menu keys
export const userBasedMenus = {
    "squarewell-partners.com": ["company", "investor", "custom", "playbook"],
    "esgds.io": ["company", "investor", "contro", "custom", "playbook"],
    "esgsure.ai": ["company", "investor", "contro", "custom", "playbook"],
    "esgds-admin": ["company", "investor", "contro", "custom", "playbook", "entity", "labs", "workflow", "dashboard"],
    "prompt_admin": ["company", "investor", "contro", "custom", "playbook", "labs", "workflow"],
    "trial-user": ["company", "custom", "playbook"],
    "external-domain": ["company", "custom", "playbook"],
};

export const userBasedRestrictedSubMenus = {
    "squarewell-partners.com": ["company-docsource", "playbook-manage", "playbook-batch-manage", "playbook-batch-create"],
    "esgds.io": [""],
    "esgsure.ai": [""],
    "esgds-admin": [""],
    "trial-user": ["company-docsource", "playbook-manage", "playbook-batch-manage", "playbook-batch-create"],
    "external-domain": ["playbook-manage", "playbook-batch-manage", "playbook-batch-create", "company-docsource", "investor-docsource"],
};

export const userBasedRestrictedChildrenSubMenus = {
    "esgds.io": [""],
    "esgsure.ai": [""],
    "esgds-admin": [""],
}

export default sidebarMenuData;